(function () {
    'ngInject';

    angular.module('app.shared.services').factory('CrosswordAPIService', crosswordAPIService);

    function crosswordAPIService(HttpService) {
        const baseURL = 'https://crossword.customily.com/generate';

        async function generateCrossword(typedText, chipTexture) {
            var myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');

            wordsArray = typedText.split(/[\s,]+/);
            const raw = { words: wordsArray };

            if (chipTexture) {
                raw.chip_image_urls = [chipTexture];
            }

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify(raw)
            };

            try {
                const response = await fetch(baseURL, requestOptions);
                const blob = await response.blob();
                return blob;
            } catch (error) {
                console.log('error', error);
                throw error;
            }
        }

        async function getTextures() {
            var url = '/Crossword/Textures';
            return HttpService.get(url);
        }

        return {
            generateCrossword,
            getTextures
        };
    }
})();
